$(document).ready(function () {
    $('[name="delivery_address"]').on('change', function() {
        if($(this).is(':checked')) {
            $('#delivery-address-fields').show();
            $('#delivery-address-fields input[data-required="true"]').attr('required', true);
        } else {
            $('#delivery-address-fields').hide();
            $('#delivery-address-fields input[data-required="true"]').attr('required', false);
        }
    });

    $('#cart-address-form').attr("novalidate", true).on('submit', function (e) {
        e.preventDefault();

        const form = $(this);

        form.find(':required').each(function () {
            $(this).removeClass('input-error');
        });

        $('button[type="submit"]').prop('disabled', true);

        if (!form[0].checkValidity()) {
            form.find(":required").each(function () {
                if (!this.checkValidity()) {
                    $(this).addClass("input-error");
                }
            });
            $('button[type="submit"]').prop('disabled', false);
            return;
        }

        const formData = new FormData(form[0]);

        $.ajax({
            type: 'POST',
            dataType: 'json',
            data: formData,
            url: '/ax_cart',
            processData: false,
            contentType: false,
            success: function (response) {
                if (response.result === 'OK') {
                    $.redirect('/koszyk', { action: 'summary' }, 'POST')
                    $('button[type="submit"]').prop('disabled', false);
                    return;
                } else {
                    openModal("#cartErrorModal");
                    $('button[type="submit"]').prop('disabled', false);
                    return;
                }
            },
            error: function () {
                openModal("#cartErrorModal");
                $('button[type="submit"]').prop('disabled', false);
                return;
            },
        })
    });
});